import React from 'react'
import style from './Layout.scss'

const LoginLayout = ({children}) => {
  return (
    <>
      <div className="contents">
        <section className={style.pageContainer}>
          <main>{children}</main>
        </section>
      </div>
    </>
  )
}

export default LoginLayout
